import { MouseEvent, useState } from "react";
import styles from "./UserActivityInfo.module.css";
import { getFormattedNumberStr } from "./Common";
import Icon from "./Icon";

interface UserActivityInfoProps {
    count: number;
    label?: string;
    type?: string;
    column?: boolean;
    size?: string;
    iconStyle?: { color?: string; cursor?: string };
    labelStyle?: { [key: string]: string };
    onClickIcon?: (e: MouseEvent<HTMLElement>) => void;
}

/**
 * @author bakim
 * @date 2024-08-21 17:48:48
 * @remark 사용자 행동 정보/버튼 컴포넌트
 * @param props UserActivityInfoProps
 * @props UserActivityInfoProps
 * @param {number} count: 누적 수 (required)
 * @param {string} label: 요소 들어갈 라벨 텍스트
 * @param {string} type: 사용자 행동 종류
 * @param {boolean} column: 세로형 여부 (기본값 가로형)
 * @param {string} size: 아이콘 사이즈
 * @param {{ color?: string; cursor?: string }} iconStyle: 아이콘 지정 스타일
 * @param {{ [key: string]: string }} labelStyle: 라벨 지정 스타일
 * @param onClickIcon: 클릭 이벤트 콜백 함수 (버튼으로 동작 시)
 * @returns UserActivityInfo
 */
const UserActivityInfo = (props: UserActivityInfoProps) => {
    const [isHover, setIsHover] = useState(false);

    const iconStyle = {
        color: props.iconStyle ? props.iconStyle.color : "lightGrey",
    };

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        props.onClickIcon && props.onClickIcon(e);
    };

    const handleMouseOver = () => {
        props.onClickIcon && setIsHover(true);
    };

    const handleMouseOut = () => {
        props.onClickIcon && setIsHover(false);
    };

    return (
        <div
            className={`${styles.container} ${props.column && styles.column} ${props.onClickIcon && styles.clickable}`}
            onClick={handleClick}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        >
            {props.type && <Icon name={props.type} size={props.size} color={isHover ? "default" : iconStyle.color} />}
            {props.label && (
                <div className={styles.label} style={props.labelStyle}>
                    {props.label}
                </div>
            )}
            <div className={styles.count} id={props.type}>
                {getFormattedNumberStr(props.count)}
            </div>
        </div>
    );
};

export default UserActivityInfo;
